import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import axios from 'axios';
import config from '../../config'; // Assuming you have a config file for API URLs
import { categoryData } from '../../ProData';


// Helper for Search Icon
const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ width: '1.25rem', height: '1.25rem' }} // Tailwind w-5 h-5
  >
    <path
      fillRule="evenodd"
      d="M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z"
      clipRule="evenodd"
    />
  </svg>
);

const SearchPage1 = () => {
  const controls = useAnimation();
  const [filters, setFilters] = useState({
    title: '',
    title1: '',
    category: '',
  });
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showError, setShowError] = useState(false); // New state for showing/hiding error
  const [info, setInfo] = useState(null); // New state for info messages
  const [showInfo, setShowInfo] = useState(false); // New state for showing/hiding info
  const [success, setSuccess] = useState(null); // New state for success messages
  const [showSuccess, setShowSuccess] = useState(false); // New state for showing/hiding success

  const resultsGridVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
      },
    },
  };

  const resultCardVariants = {
    hidden: { opacity: 0, y: 24, scale: 0.98 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { type: 'spring', stiffness: 120, damping: 14 },
    },
  };

  useEffect(() => {
    document.title = "Search - Jesuit Madurai Province Archives (JEMPARC)";
    window.scrollTo(0, 0);
    document.body.classList.add('search');
    controls.start({ opacity: 1, y: 0 });
  }, [controls]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleGroupChange=(e) =>{
    const { name, value } = e.target;
    const temp = categoryData.filter((item)=>item.subCategory===value);
    //console.log("temp : ", temp);
    setFilters((prevFilters) => ({
      ...prevFilters,
      title: value,
      title1:temp[0].category
    }));

  }

  const handleSubmit = async(e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setShowError(false);
    setInfo(null);
    setShowInfo(false);
    setSuccess(null);
    setShowSuccess(false);
    setBooks([]); // Clear previous results

 try{
      if(filters.title===""){
        setInfo("Search Value is empty Enter the search input and then hit Search button!");
        setShowInfo(true);
      }else if(filters.category===""){
        setInfo("Search Category is empty Select the search category and then hit Search button!");
        setShowInfo(true);
      }else{
        setLoading(true);
        var tempSearch=filters.title;
        if(filters.category==="Title" || filters.category==="Author"){
          tempSearch=filters.title.toLocaleLowerCase();
        }
        //const session = await Auth.currentSession();
        //const access_token=session.idToken.jwtToken;  
        //console.log("search : ", searchTopic, searchValue);
      await axios.get(`${config.api.invokeURL}/catalogue/search?fetchKey=${tempSearch}&fetchOption=${filters.category}&fetchKey1=${filters.title1}`, {
        headers: {
          //Authorization: access_token,
          'x-api-key':config.api.key
        }
      }).then(async(response) => {
       console.log("response : ", response.data[0]);
        if(response.data.length>0)
        {
       //     console.log("order status")
            setBooks(response.data);
        }
        
          setSuccess( response.data.length + " - catalogue's records found!");
          setShowSuccess(true);
        setLoading(false);

    }).catch((error)=>{
      setShowError(true);
      setError("Error Occured - " + error.message);        
    setLoading(false);
  })
}
setLoading(false);
    }catch(error){
            setShowError(true);
        setError("Error Occured - " + error.message);        
        setLoading(false);
    }
    //fetchBooks(filters);
  };


  const formContainerStyle = {
    backgroundImage: 'linear-gradient(140deg, rgba(15, 23, 42, 0.92), rgba(14, 116, 144, 0.86))',
    padding: '2rem',
    borderRadius: '1.25rem',
    boxShadow: '0 24px 50px -22px rgba(2, 132, 199, 0.55)',
    marginBottom: '2.5rem',
    border: '1px solid rgba(125, 211, 252, 0.3)',
    position: 'relative', // relative
    overflow: 'hidden', // overflow-hidden
    width: '100%',
    maxWidth: '980px',
    backdropFilter: 'blur(6px)',
  };

  const decorativeCircleStyle = {
    position: 'absolute', // absolute
    top: '-3rem',
    right: '-3rem',
    width: '10rem',
    height: '10rem',
    backgroundColor: '#22d3ee',
    opacity: '0.22',
    borderRadius: '50%', // rounded-full
    filter: 'blur(52px)',
    zIndex: '0', // z-0
  };

  const decorativeCircleSecondaryStyle = {
    position: 'absolute',
    bottom: '-3.5rem',
    left: '-2.5rem',
    width: '11rem',
    height: '11rem',
    backgroundColor: '#f59e0b',
    opacity: '0.2',
    borderRadius: '50%',
    filter: 'blur(56px)',
    zIndex: '0',
  };

  const headingStyle = {
    fontSize: 'clamp(1.6rem, 2vw, 2rem)',
    fontWeight: '800',
    marginBottom: '0.45rem',
    color: '#ecfeff',
    position: 'relative', // relative
    zIndex: '10', // z-10
    letterSpacing: '-0.02em',
    lineHeight: 1.25,
    fontFamily: '"Space Grotesk", "Poppins", sans-serif',
  };

  const headingSubTextStyle = {
    color: 'rgba(236, 254, 255, 0.85)',
    marginBottom: '1.35rem',
    fontSize: '0.95rem',
    letterSpacing: '0.01em',
    position: 'relative',
    zIndex: '10',
  };

  const formStyle = {
    display: 'flex', // flex
    flexDirection: 'row', // md:flex-row
    gap: '0.9rem',
    position: 'relative', // relative
    zIndex: '10', // z-10
    flexWrap: 'wrap',
    alignItems: 'flex-end',
  };

  const inputContainerStyle = {
    flex: '1',
    minWidth: '220px',
  };

  const inputBaseStyle = {
    width: '100%',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    paddingTop: '0.78rem',
    paddingBottom: '0.78rem',
    borderWidth: '1px',
    borderColor: 'rgba(125, 211, 252, 0.35)',
    borderRadius: '0.8rem',
    backgroundColor: 'rgba(8, 47, 73, 0.52)',
    color: '#f8fafc',
    boxShadow: 'inset 0 0 0 1px rgba(15, 118, 110, 0.12), 0 10px 30px -18px rgba(15, 23, 42, 0.9)',
    transition: 'all 0.2s ease-in-out',
    fontSize: '1rem',
    outline: 'none',
  };

  const selectStyle = {
    ...inputBaseStyle,
    color: filters.category ? '#f8fafc' : 'rgba(224, 242, 254, 0.7)',
  };

  const bookStatusContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.45rem',
    marginTop: '0.85rem',
    alignItems: 'center',
  };

  const buttonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: 'linear-gradient(120deg, #06b6d4, #0f766e)',
    color: '#ecfeff',
    fontWeight: '700',
    paddingTop: '0.78rem',
    paddingBottom: '0.78rem',
    paddingLeft: '1.7rem',
    paddingRight: '1.7rem',
    borderRadius: '0.8rem',
    boxShadow: '0 14px 24px -14px rgba(8, 145, 178, 0.8)',
    transition: 'all 0.2s ease-in-out',
    fontSize: '1rem',
    border: '1px solid rgba(207, 250, 254, 0.45)',
    cursor: 'pointer',
    flexShrink: '0',
    minWidth: '148px',
  };

  const buttonSpanStyle = {
    marginLeft: '0.5rem',
    letterSpacing: '0.01em',
  };

  const resultsContainerStyle = {
    marginTop: '0.5rem',
    width: '100%',
    maxWidth: '1080px',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '1rem',
    padding: '1rem',
  };

  const bookCardStyle = {
    background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(236, 253, 245, 0.88))',
    borderRadius: '0.95rem',
    boxShadow: '0 18px 28px -24px rgba(15, 23, 42, 0.7)',
    padding: '1.1rem',
    border: '1px solid rgba(45, 212, 191, 0.22)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    minHeight: '200px',
  };

  const bookTitleStyle = {
    fontSize: '1.05rem',
    fontWeight: '700',
    color: '#0f172a',
    marginBottom: '0.35rem',
    lineHeight: 1.35,
    fontFamily: '"Space Grotesk", "Poppins", sans-serif',
  };

  const bookDetailStyle = {
    fontSize: '0.85rem',
    color: '#334155',
    marginBottom: '0.25rem',
  };

  const bookCategoryStyle = {
    fontSize: '0.72rem',
    fontWeight: '700',
    color: '#0f766e',
    backgroundColor: '#ccfbf1',
    padding: '0.25rem 0.62rem',
    borderRadius: '9999px',
    alignSelf: 'flex-start',
    letterSpacing: '0.02em',
  };

  const bookCategoryStatusStyle = {
    fontSize: '0.72rem',
    fontWeight: '700',
    color: '#9a3412',
    backgroundColor: '#ffedd5',
    padding: '0.25rem 0.62rem',
    borderRadius: '9999px',
    alignSelf: 'flex-start',
    letterSpacing: '0.02em',
  };


  const loaderStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
    color: '#0f766e',
    fontSize: '1rem',
    fontWeight: '700',
    gap: '0.65rem',
  };

  const loaderSpinnerStyle = {
    width: '18px',
    height: '18px',
    border: '3px solid rgba(15, 118, 110, 0.2)',
    borderTop: '3px solid #0f766e',
    borderRadius: '50%',
  };

    const messageBaseContainerStyle = { // Base style for all messages
    borderRadius: '0.75rem',
    padding: '1rem',
    marginTop: '1.5rem',
    marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    //maxWidth: '700px',
    boxShadow: '0 10px 25px -22px rgba(15, 23, 42, 0.75)',
  };

  const messageBaseTextStyle = { // Base style for all message text
    fontSize: '1rem',
    marginRight: '1rem',
  };

  const errorContainerStyle = {
    ...messageBaseContainerStyle,
    backgroundColor: '#ffeaea', // Light red background
    border: '1px solid #ef4444', // Red border
  };

  const errorTextStyle = {
    ...messageBaseTextStyle,
    color: '#ef4444', // text-red-500
  };

  const infoContainerStyle = { // New style for info message container
    ...messageBaseContainerStyle,
    backgroundColor: '#e0f2fe', // Light blue background
    border: '1px solid #3b82f6', // Blue border
  };

  const infoTextStyle = { // New style for info message text
    ...messageBaseTextStyle,
    color: '#1d4ed8', // Darker blue text
  };

  const successContainerStyle = { // New style for success message container
    ...messageBaseContainerStyle,
    backgroundColor: '#dcfce7', // Light green background
    border: '1px solid #22c55e', // Green border
  };

  const successTextStyle = { // New style for success message text
    ...messageBaseTextStyle,
    color: '#15803d', // Darker green text
  };

  const closeButtonStyle = {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#ef4444', // Default close button color (can be overridden)
    fontSize: '1.25rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    transition: 'background-color 0.2s ease-in-out',
  };

  const emptyStateStyle = {
    textAlign: 'center',
    marginTop: '1.7rem',
    color: '#334155',
    background: 'rgba(255, 255, 255, 0.75)',
    border: '1px solid rgba(148, 163, 184, 0.22)',
    borderRadius: '0.9rem',
    padding: '1rem 1.2rem',
    boxShadow: '0 12px 26px -24px rgba(15, 23, 42, 0.65)',
  };

  const toTitleCase = (text) => {
  if (!text) return "";

  return text
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

  return (
    <div style={{
      fontFamily: '"Sora", "Poppins", sans-serif',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      backgroundImage: 'radial-gradient(circle at 20% 20%, #cffafe 0%, #f0fdfa 34%, #f8fafc 65%, #ecfeff 100%)',
      padding: '2rem 0.7rem',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <motion.div
        style={{
          position: 'absolute',
          width: '260px',
          height: '260px',
          backgroundColor: 'rgba(6, 182, 212, 0.14)',
          borderRadius: '50%',
          filter: 'blur(70px)',
          top: '12%',
          left: '-80px',
        }}
        animate={{ x: [0, 20, 0], y: [0, -15, 0] }}
        transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        style={{
          position: 'absolute',
          width: '240px',
          height: '240px',
          backgroundColor: 'rgba(245, 158, 11, 0.11)',
          borderRadius: '50%',
          filter: 'blur(64px)',
          bottom: '8%',
          right: '-70px',
        }}
        animate={{ x: [0, -22, 0], y: [0, 16, 0] }}
        transition={{ duration: 9, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        style={formContainerStyle}
        initial={{ opacity: 0, y: 40 }}
        animate={controls}
        transition={{ type: 'spring', stiffness: 60, damping: 14 }}
      >
        <motion.div
          style={decorativeCircleStyle}
          animate={{ scale: [1, 1.1, 1] }}
          transition={{ repeat: Infinity, duration: 3 }}
        />
        <motion.div
          style={decorativeCircleSecondaryStyle}
          animate={{ scale: [1, 1.06, 1] }}
          transition={{ repeat: Infinity, duration: 4.2 }}
        />
        <motion.h2
          style={headingStyle}
          initial={{ x: -30, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Discover Archive Books and Research Records
        </motion.h2>
        <p style={headingSubTextStyle}>
          Search by title, author, classification, research, or document type and explore curated catalogue details.
        </p>
        {showError && error && (
        <motion.div
          style={errorContainerStyle}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <span style={errorTextStyle}>{error}</span>
          <button
            style={closeButtonStyle}
            onClick={() => setShowError(false)}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.1)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            &times;
          </button>
        </motion.div>
      )}

      {showInfo && info && ( // Info message display
        <motion.div
          style={infoContainerStyle}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <span style={infoTextStyle}>{info}</span>
          <button
            style={{ ...closeButtonStyle, color: '#1d4ed8' }} // Override close button color for info
            onClick={() => setShowInfo(false)}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(59, 130, 246, 0.1)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            &times;
          </button>
        </motion.div>
      )}

      {showSuccess && success && ( // Success message display
        <motion.div
          style={successContainerStyle}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <span style={successTextStyle}>{success}</span>
          <button
            style={{ ...closeButtonStyle, color: '#15803d' }} // Override close button color for success
            onClick={() => setShowSuccess(false)}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(34, 197, 94, 0.1)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            &times;
          </button>
        </motion.div>
      )}

        <form onSubmit={handleSubmit} style={formStyle}>
          <motion.div style={inputContainerStyle} whileFocus={{ scale: 1.04 }}>
            <select
              name="category"
              value={filters.category}
              onChange={handleInputChange}
              style={selectStyle}
            >
              <option value="">Search Categories</option>
              <option value="Title">Title</option>
              <option value="TamilTitle">Tamil Title</option>
              <option value="Author">Author</option>
              {/*<option value="Category">Category</option>*/}
              <option value="SubCategory">Classification</option>
              <option value="Research">Research</option>
              <option value="Documents">Documents</option>
            </select>
          </motion.div>
          {filters.category==="Category"?
          <motion.div style={inputContainerStyle} whileFocus={{ scale: 1.04 }}>
            <select
              name="title"
              value={filters.title}
              onChange={handleInputChange}
              placeholder="Search your materials..."
              style={inputBaseStyle}
            >
              <option value="Tamil Catalogue">Tamil</option>
              <option value="Library Catalogue">Library</option>
              <option value="Archives Catalogue">Archives</option>
              </select>
          </motion.div>:filters.category==="SubCategory"?
           <motion.div style={inputContainerStyle} whileFocus={{ scale: 1.04 }}>
            <select
              name="title"
              value={filters.title}
              onChange={handleGroupChange}
              //placeholder="Book title..."
              style={inputBaseStyle}
            >
              {categoryData.map((item, index)=>{return(
                <option value={item.subCategory} key={index}>{item.subCategory}</option>
              )})}
              </select>
          </motion.div>
          :<motion.div style={inputContainerStyle} whileFocus={{ scale: 1.04 }}>
            <input
              type="text"
              name="title"
              value={filters.title}
              onChange={handleInputChange}
              placeholder="Search your materials..."
              style={inputBaseStyle}
            />
          </motion.div>}
          {/*<motion.div style={inputContainerStyle} whileFocus={{ scale: 1.04 }}>
            <input
              type="text"
              name="author"
              value={filters.author}
              onChange={handleInputChange}
              placeholder="Author's name..."
              style={inputBaseStyle}
            />
          </motion.div>*/}
          
          <motion.button
            type="submit"
            style={buttonStyle}
            whileHover={{ scale: 1.04, y: -2, boxShadow: '0 14px 26px -14px rgba(13, 148, 136, 0.85)' }}
            whileTap={{ scale: 0.98 }}
          >
            <SearchIcon />
            <span style={buttonSpanStyle}>Search</span>
          </motion.button>
        </form>
      </motion.div>

      {/* Book Search Results Section */}
      {loading && (
        <div style={loaderStyle}>
          <motion.span
            style={loaderSpinnerStyle}
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 0.85, ease: 'linear' }}
          />
          Loading results...
        </div>
      )}

      {/*error && (
        <div style={errorStyle}>
          {error}
        </div>
      )*/}

      {/*dispMsg && (
        <div style={errorStyle}>
          {dispMsg}
        </div>
      )*/}

      {!loading && !error && books.length > 0 && (
        <motion.div
          style={resultsContainerStyle}
          variants={resultsGridVariants}
          initial="hidden"
          animate="show"
        >
          {books.map((book, index) => (
            <motion.div
              key={book.id || `${book.bookNo}-${index}`}
              style={bookCardStyle}
              variants={resultCardVariants}
              whileHover={{ y: -6, boxShadow: '0 24px 36px -30px rgba(15, 23, 42, 0.9)' }}
            >
              <h3 style={bookTitleStyle}>{toTitleCase(book.title)}</h3>
              {book.category === "Tamil Catalogue" && book.titleInTamil !== "NA" ? <h3 style={bookTitleStyle}>{book.titleInTamil}</h3> : null}
              <p style={bookDetailStyle}>Author: {toTitleCase(book.author)}</p>
              <p style={bookDetailStyle}>Book No: {book.bookNo}</p>
              <div style={bookStatusContainerStyle}>
                <span style={bookCategoryStyle}>{book.category || 'Catalogue'}</span>
                <span style={bookCategoryStyle}>Shelf: {book.selfNo || 'N/A'}</span>
                <span style={bookCategoryStatusStyle}>{book.catalogueStatus || 'Status N/A'}</span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      )}

      {!loading && !error && books.length === 0 && filters.title === '' && filters.category === '' && (
        <div style={emptyStateStyle}>
          Start by searching for books using the fields above!
        </div>
      )}

      {!loading && !error && books.length === 0 && (filters.title !== '' || filters.category !== '') && (
        <div style={emptyStateStyle}>
          No books found matching your criteria. Try a different search!
        </div>
      )}
    </div>
  );
};

export default SearchPage1;
